/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <gnu.org/licenses>.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <div class="ion-page">
    <ion-header no-border>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-back-button default-href="/carpools/home"></ion-back-button>
        </ion-buttons>
        <h1 class="ion-text-center">{{ $t('PostEvent.title') }}</h1>
      </ion-toolbar>
    </ion-header>

    <ion-content color="primary" no-bounce>
      <div class="mc-white-container mc-post-event" v-if="eventToPost">
        <!-- Bloc photo -->
        <div class="mc-user-update-profile ion-margin-bottom" >
          <div class="mc-user-image">
            <ion-thumbnail>
              <img v-if="image" :src="image" alt="">
            </ion-thumbnail>
          </div>

          <div>
          <ion-button class='mc-small-button' color="primary" fill="outline" @click="$refs.imageInput.click()">
            <ion-icon class="ion-margin-end" name="create"></ion-icon> {{ $t('UpdateProfile.photo') }}
          </ion-button>
          <div class="info-photo text-center">
            4Mo max, 200x200px min, png ou jpg
          </div>
          <input ref="imageInput" style="display: none" type="file" @change="changePicture($event)" />
          </div>
        </div>

        <ion-item>
          <ion-label position="floating">{{$t('PostEvent.name')}} *</ion-label>
          <ion-input
            type="text"
            :placeholder="$t('PostEvent.name')"
            :value="eventToPost.name"
            @input="eventToPost.name = $event.target.value"
          ></ion-input>
        </ion-item>
        <div v-if="$v.eventToPost.name.$error">
          <div
            class="mc-error-label"
            v-if="!$v.eventToPost.name.required"
          >{{$t('Validation.required')}}</div>
        </div>

        <ion-item>
          <ion-label position="floating">{{$t('PostEvent.url')}}</ion-label>
          <ion-input
            type="text"
            :placeholder="$t('PostEvent.url')"
            :value="eventToPost.url"
            @input="eventToPost.url = $event.target.value;"
          ></ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="floating">{{$t('PostEvent.description')}}</ion-label>
          <ion-input
            type="text"
            :placeholder="$t('PostEvent.description')"
            :value="eventToPost.description"
            @input="eventToPost.description = $event.target.value"
          ></ion-input>
        </ion-item>
        <div v-if="$v.eventToPost.description.$error">
          <div
            class="mc-error-label"
            v-if="!$v.eventToPost.description.required"
          >{{$t('Validation.required')}}</div>
          <div class="mc-error-label"  v-if="!$v.eventToPost.description.maxLength">{{$t('Validation.maxLength', { value: 255 })}}</div>
        </div>

        <ion-item>
          <ion-label position="floating">{{$t('PostEvent.fullDescription')}} *</ion-label>
          <ion-textarea
            required
            :value="eventToPost.fullDescription"
            @ionChange="eventToPost.fullDescription = $event.target.value"
            :placeholder="$t('PostEvent.fullDescription')"
          ></ion-textarea>
        </ion-item>
        <div v-if="$v.eventToPost.fullDescription.$error">
          <div
            class="mc-error-label"
            v-if="!$v.eventToPost.fullDescription.required"
          >{{$t('Validation.required')}}</div>
        </div>
        <ion-item v-on:click="goGeoSearch('update_user_address', 'search')">
          <ion-label position="floating">{{$t('PostEvent.address')}} *</ion-label>
          <ion-input
            type="text"
            name="address"
            :value="formatAddress(eventToPost.address)"
            readonly="true"
            class="no-clickable ellipsis"
            v-bind:placeholder="$t('Register.address')"
          ></ion-input>
        </ion-item>
        <div v-if="$v.eventToPost.address.$error">
          <div
            class="mc-error-label"
            v-if="!$v.eventToPost.address.required"
          >{{$t('Validation.required')}}</div>
        </div>

        <ion-item>
          <ion-label position="floating">Date de début *</ion-label>
          <ion-datetime
            display-format="DD/MM/YY"
            picker-format="DD/MM/YY"
            cancel-text="Annuler"
            done-text="Valider"
            :placeholder="$t('PostEvent.fromDate')"
            :value="eventToPost.fromDate"
            @ionChange="eventToPost.fromDate = $event.detail.value"
          ></ion-datetime>
        </ion-item>
        <div v-if="$v.eventToPost.fromDate.$error">
          <div
            class="mc-error-label"
            v-if="!$v.eventToPost.fromDate.required"
          >{{$t('Validation.required')}}</div>
        </div>


        <ion-item v-if="!! eventToPost.fromDate">
          <ion-label position="floating">Heure de début</ion-label>
          <ion-datetime
            display-format="HH:mm"
            picker-format="HH:mm"
            cancel-text="Annuler"
            done-text="Valider"
            placeholder="Heure de début"
            :value="eventToPost.fromDate"
            @ionChange="changeBeginHour($event.detail.value)"
          ></ion-datetime>
        </ion-item>

        <ion-item>
          <ion-label position="floating">Date de fin *</ion-label>
          <ion-datetime
            display-format="DD/MM/YY"
            picker-format="DD/MM/YY"
            cancel-text="Annuler"
            done-text="Valider"
            :placeholder="$t('PostEvent.toDate')"
            :value="eventToPost.toDate"
            @ionChange="eventToPost.toDate = $event.detail.value"
          ></ion-datetime>
        </ion-item>
        <div v-if="$v.eventToPost.toDate.$error">
          <div
            class="mc-error-label"
            v-if="!$v.eventToPost.toDate.required"
          >{{$t('Validation.required')}}</div>
        </div>

        <ion-item v-if="!! eventToPost.toDate">
          <ion-label position="floating">Heure de fin</ion-label>
          <ion-datetime
            display-format="HH:mm"
            picker-format="HH:mm"
            cancel-text="Annuler"
            done-text="Valider"
            placeholder="Heure de fin"
            :value="eventToPost.toDate"
            @ionChange="changeEndHour($event.detail.value)"
          ></ion-datetime>
        </ion-item>


        <div class="mc-select-communities text-left" v-if="linkCommunity &&  this.$store.getters.userCommunities && this.$store.getters.userCommunities.length > 0">
          <ion-icon
            size="large"
            color="primary"
            class="rotating"
            v-if="this.$store.getters.statusUserCommunities == 'loading'"
            name="md-sync"
          ></ion-icon>
          <ion-item class="item-communities">
            <ion-label position="floating">{{$t('PostEvent.community')}}</ion-label>
            <ion-select
              v-if="this.$store.getters.userCommunities && this.$store.getters.statusUserCommunities == 'success'"
              placeholder="Sélectionnez une communauté"
              interface="alert"
              multiple="true"
              cancel-text="Fermer"
              ok-text="Valider"
              :value="eventToPost.community"
              @ionChange="setCommunities($event)"
            >
              <ion-select-option
                v-for="community in this.$store.getters.userCommunities"
                :key="community['@id']"
                :value="community['@id']"
              >{{ community.name }}</ion-select-option>
            </ion-select>
          </ion-item>
        </div>


        <br />
        <ion-button class="mc-small-button" color="success" expand="block" @click="PostEvent()">
          <span v-if="this.$store.getters.statusPostEvent == 'loading'">
            <ion-icon size="large" class="rotating" name="md-sync"></ion-icon>
          </span>
          <span v-if="this.$store.getters.statusPostEvent != 'loading'">{{ $t('PostEvent.create') }}</span>
        </ion-button>
      </div>
    </ion-content>
  </div>
</template>

<style lang="scss">
.mc-post-event {
  .mc-post-event-avatar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: var(--ion-color-primary);

    ion-thumbnail {
      --size: 90px;
      --border-radius: 50%;
    }
  }
  ion-item {
    margin-top: 20px;
  }
}

.info-photo {
  font-size: 9px;
  line-height: 9px;
  margin-top: 3px;
}
</style>

<script>
import {
  required,
  maxLength,
} from "vuelidate/lib/validators";
import { toast } from "../../../Shared/Mixin/toast.mixin";
import { address } from "../../../Shared/Mixin/address.mixin";
import Compressor from 'compressorjs';

export default {
  name: "post-event",
  mixins: [toast, address],
  data() {
    return {
      image: null,
      linkCommunity: JSON.parse(process.env.VUE_APP_LINK_COMMUNITY_TO_EVENT)
    }
  },
  validations: {
    eventToPost: {
      name: {
        required
      },
      description: {
        maxLength: maxLength(255)
      },
      fullDescription: {
        required
      },
      address: {
        required
      },
      fromDate: {
        required
      },
      toDate: {
        required
      }
    }
  },
  computed: {
    eventToPost() {
      return this.$store.getters.postEvent;
    },
    file() {
      return this.$store.state.eventStore.file;
    }
  },
  created() {
    if (!!!this.eventToPost) {
      this.$store.commit("init_post_event");
    }

  },
  mounted() {
    if (this.file) {
      this.getBase64(this.file);
    }
  },
  methods: {
    PostEvent() {
      this.$v.$reset();
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.presentToast(this.$t("PostEvent.missingInfo"), "danger");
      } else {

         this.eventToPost.user = this.$store.getters.user["@id"];
         if (!!!this.eventToPost.private) {
           this.eventToPost.private = false;
         }

        this.eventToPost.fromDate = this.$moment(this.eventToPost.fromDate).format();
        this.eventToPost.toDate = this.$moment(this.eventToPost.toDate).format();

         this.$store
          .dispatch("postEvent", this.eventToPost)
          .then(resp => {
            this.presentToast(this.$t("Event.success"), "success");
            if (this.file) {
              this.$store.dispatch("updateEventPicture", {eventId: resp.data.id, eventFile: this.file}).then(() => {
                this.$store.commit("init_post_event");
                this.$router.back();
              }).catch( () => {
                this.$store.commit("init_post_event");
                this.$router.back();
              });
            } else {
              this.$store.commit("init_post_event");
              this.$router.back();
            }

          })
          .catch(err => {
            this.presentToast(this.$t("Commons.error"), "danger");
          });
      }
    },


    goGeoSearch(type, action) {
      this.$router.push({
        name: "geoSearch",
        query: { type: "update_event_address", action: "search" }
      });
    },

    changeBeginHour(value) {
      const hour = this.$moment(value).format('HH');
      const min = this.$moment(value).format('mm');

      const date = new Date(this.eventToPost.fromDate);
      date.setHours(hour);
      date.setMinutes(min);
      this.eventToPost.fromDate = this.$moment(date).format();
      this.eventToPost.useTime = true;
    },

    changeEndHour(value) {
      const hour = this.$moment(value).format('HH');
      const min = this.$moment(value).format('mm');

      const date = new Date(this.eventToPost.toDate);
      date.setHours(hour);
      date.setMinutes(min);
      this.eventToPost.toDate = this.$moment(date).format();
      this.eventToPost.useTime = true;
    },
    changePicture(e) {
      const file = e.target.files[0];
      if (file) {
        this.compressFile(file);
      }
    },
    compressFile: function (file) {
      const context = this;
      new Compressor(file, {
        convertSize: 1000000,
        success(result) {
          if (result) {
            const f = new File([result], file.name, {type: result.type});
            context.$store.state.eventStore.file = f;
            context.getBase64(f);
          }
        },
        error(err) {
          context.presentToast(this.$t("Commons.error"), 'danger')
        },
      });
    },
    getBase64(file) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.image = reader.result
      };
      reader.onerror = (error) => {
        console.log('Error: ', error);
      };
    },
    setCommunities(event) {
      this.eventToPost.community = event.detail.value;
    }
  }
};
</script>
